import React from "react";
import { Trans, WithTranslation } from "react-i18next";

const ManageAccountLink = (props: { children?: React.ReactNode }) => (
    <a
        href="https://support.beautiful.ai/hc/en-us/sections/360006956931-Managing-your-Billing"
        target="_blank"
        rel="noreferrer"
    >
        {props.children}
    </a>
);

type TranslationFn = WithTranslation["t"];

type Props = {
    t: TranslationFn;
    daysUntilDowngrade: number;
};

export function PaymentIssueDialogMessage({ t, daysUntilDowngrade }: Props) {
    return (
        <Trans
            t={t}
            i18nKey="You have <bold>{{days}} days</bold> to update your payment information before your account is downgraded. Learn more about managing your account <manageAccountLink>here</manageAccountLink>."
            components={{
                bold: <b />,
                manageAccountLink: <ManageAccountLink />
            }}
            values={{ days: daysUntilDowngrade }}
        />
    );
}
